import { IFormContext }           from 'rewire-ui';
import DataMutations              from '../graphql/Mutations';
import DataQueries                from '../graphql/Queries';
import mainPageModel              from '../main-navigation/MainPageModel';
import { roleSearcher } from '../utility/Searchers';
import DocumentDialogModel, {
  DocumentSchema
}                                 from './DocumentDialogModel';

const UserSchema = `
  ${DocumentSchema}
  email
  userSecurity {
    role {
      id
      code
      name
    }
  }
  phone {
    home
    mobile
    work
    fax
    workFax
  }
`;

export class UserDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'User',
      (ids: string[]) => DataQueries.getUsersByIds(UserSchema, ids),
      async (_schema: string, _objs: any[]) => { return undefined; },
      DataMutations.updateUsers,
      async function (_ids: string[]): Promise<any> {
        const email = this.form.field?.email?.value;
        if (!email) return;
        return await DataMutations.deleteUser(email);
      },
      'users',
      () => mainPageModel.canAddUsers,
      () => mainPageModel.canEditUsers,
      () => mainPageModel.canDeleteUsers,
    );
  }

  mapToSave(): ObjectType {
    const obj = super.mapToSave();
    if (obj?.userSecurity?.role?.id) {
      obj.roleId = obj.userSecurity.role.id;
      delete obj.userSecurity;
    }
    return obj;
  }

  protected otherFields(form: IFormContext) {
    return {
      email:     form.static().label('Email').placeholder('enter email'),
      role:      form.select(roleSearcher).accessor(['userSecurity', 'role']).label('Role'),
      phone:     form.phone({icon: 'phone'}).accessor(['phone', 'home'])   .label('Home')    .placeholder('enter home phone number'),
      mobile:    form.phone({icon: 'phone'}).accessor(['phone', 'mobile']) .label('Mobile')  .placeholder('enter mobile phone number'),
      work:      form.phone({icon: 'phone'}).accessor(['phone', 'work'])   .label('Work')    .placeholder('enter work phone number'),
      fax:       form.phone({icon: 'phone'}).accessor(['phone', 'fax'])    .label('Fax')     .placeholder('enter fax number'),
      workFax:   form.phone({icon: 'phone'}).accessor(['phone', 'workFax']).label('Work Fax').placeholder('enter work fax number'),
    };
  }
}

const userDialogModel = new UserDialogModel();
export default userDialogModel;
